import { capitalize } from 'lodash';

export const getFullName = (firstName: string | undefined, lastName: string | undefined): string =>
	`${capitalize(firstName)} ${capitalize(lastName)}`;
